import React from "react";
import styled from "styled-components";
import ProgressBar from "./ProgressBar";
import { designTokens, getTypography } from "styles/designTokens";
import { useUploadStore } from "store/uploadStore";

const UploadTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 0;
  gap: 10px;
  width: 252px;
`;

const UploadTitle = styled.div<{ $uploading?: boolean }>`
  ${getTypography("korean", "body2").letterSpacing};
  color: ${designTokens.colors.font.secondary};
`;

const UploadSubtitle = styled.div`
  ${getTypography("korean", "body3").letterSpacing};
  color: ${designTokens.colors.font.quaternary};
`;

interface UploadTextProps {
  isUploading: boolean;
  percent: number;
  message?: string;
}

const UploadText: React.FC<UploadTextProps> = React.memo(
  ({ isUploading, percent, message }) => {
    const cancelUpload = useUploadStore((state) => state.cancelUpload);

    return (
      <UploadTextGroup>
        <UploadTitle $uploading={isUploading}>
          {isUploading
            ? (message || `분석중입니다. 잠시만 기다려 주세요.`)
            : "파일을 선택하거나 이곳에 드래그하세요."}
        </UploadTitle>
        {!isUploading && (
          <UploadSubtitle>
            mp4, mp3, wav, aac, flac 파일 형식 <br />
            최대 2GB
          </UploadSubtitle>
        )}
        {isUploading && (
          <ProgressBar percent={percent} onCancel={cancelUpload} />
        )}
      </UploadTextGroup>
    );
  }
);

UploadText.displayName = "UploadText";

export default UploadText;
